var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0003 10.9546H8.18213M19.0003 17.1365H8.18213M19.0003 4.77283H8.18213",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54391 6.3182C4.31664 6.3182 5.08936 5.54548 5.08936 4.77275C5.08936 4.00002 4.31664 3.22729 3.54391 3.22729C2.77118 3.22729 2 4.00002 2 4.77275C2 5.54548 2.77118 6.3182 3.54391 6.3182ZM3.54391 12.5C4.31664 12.5 5.08936 11.7273 5.08936 10.9546C5.08936 10.1818 4.31664 9.40911 3.54391 9.40911C2.77118 9.40911 2 10.1818 2 10.9546C2 11.7273 2.77118 12.5 3.54391 12.5ZM3.54391 18.6818C4.31664 18.6818 5.08936 17.9091 5.08936 17.1364C5.08936 16.3637 4.31664 15.5909 3.54391 15.5909C2.77118 15.5909 2 16.3637 2 17.1364C2 17.9091 2.77118 18.6818 3.54391 18.6818Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/Features.2cf50eace0df0380964c227fdc4e8ba8.svg";
export { ForwardRef as ReactComponent };